module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Envelope_16"],"path":[{"$":{"d":"M8,8.11.14,2H15.86Zm-3.53-1L0,3.66V12Zm6,.86L8,9.89,5.58,8,.11,14H15.89Zm1.11-.86L16,12V3.66Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Envelope_16.svg
// module id = YLdJ
// module chunks = 1